/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import { Modal } from "antd";
import "../../pages/Home/home.scss";
import { UploadOutlined } from "@ant-design/icons";
import { Upload } from "antd";
import { Divider } from "../../../node_modules/antd/es/index";
import ImgCrop from "antd-img-crop";
import { ValidateUSCanadaFileUploads } from "./ValidateFlightUser";
import { useSelector } from "react-redux";
// import imageCompression from "browser-image-compression";
let muploadsArray = [];

export default function OtherPassportsFileModal({
  show,
  handleClose,
  passportCount,
  getUSCanadaPassports,
  // getUSCanadaErrors,
}) {
  const [errors, setErrors] = useState([]);
  const [passportCountState, setPassportCount] = useState(null);
  // const [fileList, setFileList] = useState([
  //   {
  //     uid: '-1',
  //     url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
  //   },
  // ]);
  const { usCanadaPassports } = useSelector((state) => state.flightSearch);

  const [uploadsArray, setUploadsArray] = useState([
    {
      passport_front_page: null,
      avatar_photo: null,
      passport_preview: null,
      photo_preview: null,
    },
  ]);

  useEffect(() => {
    if (usCanadaPassports) {
      console.log("---------", usCanadaPassports);
      let selectedFiles = JSON.parse(usCanadaPassports);
      setUploadsArray(selectedFiles);
    }
  }, [usCanadaPassports]);

  useEffect(() => {
    setPassportCount(passportCount);
  }, [passportCount]);

  useEffect(() => {
    console.log("Passport Count State111", passportCountState);
    console.log("Passport Count passportCount", passportCount);
    if (passportCount) {
      [...Array(passportCount)].map((d, index) => {
        console.log("uploadsArray[index]", uploadsArray[index]);
        muploadsArray = [
          ...muploadsArray,
          {
            passport_front_page:
              uploadsArray.length > 0
                ? uploadsArray[index]
                  ? uploadsArray[index]?.passport_front_page
                  : null
                : null,
            avatar_photo:
              uploadsArray.length > 0
                ? uploadsArray[index]
                  ? uploadsArray[index]?.avatar_photo
                  : null
                : null,
            passport_preview:
              uploadsArray.length > 0
                ? uploadsArray[index]
                  ? uploadsArray[index]?.passport_preview
                  : null
                : null,
            photo_preview:
              uploadsArray.length > 0
                ? uploadsArray[index]
                  ? uploadsArray[index]?.photo_preview
                  : null
                : null,
          },
        ];

        return null;
      });

      setUploadsArray(muploadsArray);
      // } else {
      //   let newPassportCOunt = passportCount - uploadsArray.length;

      //   let muploadsArray = [];
      //   [...Array(newPassportCOunt)].map((d) => {
      //     muploadsArray = [
      //       ...muploadsArray,
      //       {
      //         passport_front_page: null,
      //         avatar_photo: null,
      //         passport_preview: null,
      //         photo_preview: null,
      //       },
      //     ];

      //     return null;
      //   });
      // setUploadsArray([...uploadsArray, ...muploadsArray]);
    }
  }, [passportCount]);

  // useEffect(() => {
  //   dispatch({
  //     type: flightActionTypes.SET_US_CANADA_PASSPORTS,
  //     payload: uploadsArray,
  //   });
  //   console.log("filesArray...");
  //   // setUploadsArray(muploadsArray);
  // }, [uploadsArray]);
 
  const handleFileChange = async (file, name, previewName, index) => {
   
    try {
     
      const filesArray = [...uploadsArray];
      filesArray[index][name] = file;
      filesArray[index][previewName] = URL.createObjectURL(file);
      if (errors && errors.length > 0) errors[index][name] = null;
      setUploadsArray(filesArray);
      setErrors(errors);
      // await uploadToServer(compressedFile); // write your own logic
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpload = () => {
    const errorsq = ValidateUSCanadaFileUploads(uploadsArray);
    // let allerr = values(errorsq,"")
    let errorValues = [];
    errorsq.map((d) => {
      errorValues = [...errorValues, d.passport_front_page, d.avatar_photo];
      return null;
    });
    console.log("Errors", errorValues);

    if (errorValues.every((d) => d === null)) {
      // setState({ ...state, errors: errors.errors, submitting: false });
      getUSCanadaPassports(uploadsArray);

      handleClose();
    } else {
      setErrors(errorsq);
    }
  };

  const handleRemove = (name, previewName, index) => {
    const filesArray = [...uploadsArray];
    filesArray[index][name] = null;
    filesArray[index][previewName] = null;
    if (errors && errors.length > 0) errors[index][name] = null;

    setUploadsArray(filesArray);
    // setUploadsArray(uploadsArray.splice(i, 1));
  };
  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  // const onChange = ({ fileList: newFileList }) => {
  //   setFileList(newFileList);
  // };

  console.log("uploadsArray", uploadsArray);
  return (
    <Modal
      open={show}
      onCancel={() => {
        handleClose();
      }}
      centered
      closable={true}
      maskClosable={false}
      footer={false}
      title="Upload Passport For US/Canada Nationality"
      className="modal-image-upload"
      width="40%"
    >
      <div className="upload-controls-container">
        {uploadsArray.map((d, index) => {
          return (
            <div>
              <Divider orientation="left">Applicant {index + 1}</Divider>
              <div
                style={{
                  display: "flex",
                  justifyContent: "",
                  flexWrap: "wrap",
                }}
              >
                <div className="image-container">
                  <label className="font-weight-bold"> Passport</label>
                  <ImgCrop showGrid rotationSlider aspectSlider showReset>
                    <Upload
                      beforeUpload={(file) => {
                        console.log("file", URL.createObjectURL(file));
                        handleFileChange(
                          file,
                          "passport_front_page",
                          "passport_preview",
                          index
                        );
                        return false;
                      }}
                      onRemove={(e) =>
                        handleRemove(
                          "passport_front_page",
                          "passport_preview",
                          index
                        )
                      }
                      listType="picture-card"
                      showUploadList={{
                        showPreviewIcon: true,
                        showRemoveIcon: true,
                      }}
                      onPreview={onPreview}
                      className="mt-3"
                      maxCount={1}
                      file={uploadsArray[index].passport_front_page}
                    >
                      {uploadsArray[index].passport_preview === null && (
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div className="text-image-container">
                            <UploadOutlined style={{ fontSize: 40 }} />{" "}
                            {/* <span className="text-image">Passport Front</span> */}
                          </div>
                        </div>
                      )}
                      {/* <Button icon={<UploadOutlined />}>Passport Front Page</Button> */}
                    </Upload>
                  </ImgCrop>
                  {errors && errors[index] && (
                    <span className="text-danger font-size-12">
                      {errors[index].passport_front_page}
                    </span>
                  )}
                </div>

                <div className="image-container">
                  <label className="font-weight-bold">Photo</label>
                  {/* <Divider orientation="left">Photo</Divider> */}
                  <div>
                    {/* <div className="preview-img-card">
                      <img
                        alt="example"
                        src="https://os.alipayobjects.com/rmsportal/QBnOOoLaAfKPirc.png"
                      />
                    </div> */}
                    {/* <div className="preview-img-card">
                        <img
                          alt="example"
                          src="https://os.alipayobjects.com/rmsportal/QBnOOoLaAfKPirc.png"
                        />
                      </div> */}
                    <ImgCrop showGrid rotationSlider aspectSlider showReset>
                      <Upload
                        beforeUpload={(file) => {
                          console.log("file", URL.createObjectURL(file));
                          handleFileChange(
                            file,
                            "avatar_photo",
                            "photo_preview",
                            index
                          );
                          return false;
                        }}
                        onRemove={(e) =>
                          handleRemove("avatar_photo", "photo_preview", index)
                        }
                        listType="picture-card"
                        showUploadList={{
                          showPreviewIcon: true,
                          showRemoveIcon: true,
                        }}
                        // showUploadList={false}
                        onPreview={onPreview}
                        className="mt-3"
                        maxCount={1}
                      >
                        {uploadsArray[index].photo_preview === null && (
                          <div
                            className="image-list"
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <div className="text-image-container">
                              <UploadOutlined style={{ fontSize: 40 }} />{" "}
                            </div>
                          </div>
                        )}
                      </Upload>
                    </ImgCrop>
                  </div>
                  {errors && errors[index] && (
                    <span className="text-danger font-size-12">
                      {errors[index].avatar_photo}
                    </span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
        {/* </RSC> */}
        <Divider />
      </div>

      {/* </div> */}
      <div className="footer-modal">
        <button className="btn btn-dark blue" onClick={handleUpload}>
          Upload Documents
        </button>
      </div>
    </Modal>
  );
}
